export const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};
export const validateName = (name) => {
  // name must be atleast 3 characters long
  const re = /^[a-zA-Z ]{3,}$/;
  return re.test(name);
};
export const validatePhone = (phoneNumber) => {
  if (!phoneNumber) return false;
  const digits = phoneNumber.replace(/[^0-9]/g, "");
  return digits.length >= 10 && digits.length <= 15;
};

export const formatToE164 = (phone, countryCode = "+91") => {
  if (!phone) return "";
  const cleaned = phone.replace(/[^0-9]/g, "");
  if (phone.startsWith("+")) {
    return `+${cleaned}`;
  }
  if (cleaned.length === 10) {
    const code = countryCode.startsWith("+") ? countryCode : `+${countryCode}`;
    return `${code}${cleaned}`;
  }
  if (cleaned.length === 12 && cleaned.startsWith("91")) {
    return `+${cleaned}`;
  }
  return `+${cleaned}`;
};
export const validatePassword = (password) => {
  // Require at least 8 characters, one uppercase letter, one lowercase letter, and one digit
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
  return re.test(password);
};
